var _rect, _path, _rect2, _line, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 94,
    height: 15,
    fill: "#1a1a1a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "     M 3,18     A 7.83,7.83 0 0,0 18.67,18     A 7.83,7.83 0 0,0 34.33,18     A 7.83,7.83 0 0,0 50,18     A 7.83,7.83 0 0,0 65.67,18     A 7.83,7.83 0 0,0 81.33,18     A 7.83,7.83 0 0,0 97,18     L 97,3 L 3,3 Z   ",
    fill: "transparent",
    stroke: "#1a1a1a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 94,
    height: 79,
    rx: 1,
    fill: "none",
    stroke: "#1a1a1a",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 97,
    y2: 18,
    stroke: "#1a1a1a",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 46,
    width: 26,
    height: 34,
    rx: 1,
    fill: "transparent",
    stroke: "#1a1a1a",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 63,
    width: 3.5,
    height: 3.5,
    rx: 0.5,
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.a9b07b9cfbb5c0204cc30beb8d892e5f.svg";
export { ForwardRef as ReactComponent };